import {BookmarksOrderBy} from '~shared/models';

export const toBookmarksOrderBy = (sortBy: string) => {
    let orderBy: BookmarksOrderBy = 'created_at';
    switch (sortBy) {
        case 'title':
            orderBy = 'page.title';
            break;
        case 'slug':
            orderBy = 'page.slug';
            break;
        case 'author':
            orderBy = 'page.author';
            break;
        case 'pageModifiedAt':
            orderBy = 'page.modified_at';
            break;
        case 'pageCreatedAt':
            orderBy = 'page.created_at';
            break;
        case 'createdAt':
            orderBy = 'created_at';
            break;
        case 'pageExpiresAt':
            orderBy = 'expires_at';
            break;
        default:
            break;
    }
    return orderBy;
};
